import React, { useState } from 'react';

function StepNine({ formData, onNext }) {
    const [bankName, setBankName] = useState(formData.bankName || '');
    const [accountHolder, setAccountHolder] = useState(formData.accountHolder || '');
    const [sortCode, setSortCode] = useState(formData.sortCode || '');
    const [accountNumber, setAccountNumber] = useState(formData.accountNumber || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!bankName || !accountHolder || !sortCode || !accountNumber) {
            setError('Please fill out all required bank details.');
            return;
        }

        setError('');
        onNext({
            bankName,
            accountHolder,
            sortCode,
            accountNumber,
        });
    };

    const isFormValid = bankName && accountHolder && sortCode && accountNumber;

    return (
        <div className="step-form">
            <h6 className="mb-4">Tax and Bank Details</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Bank Name"
                            value={bankName}
                            onChange={e => setBankName(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Name of Account Holder"
                            value={accountHolder}
                            onChange={e => setAccountHolder(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Sort Code"
                            value={sortCode}
                            onChange={e => setSortCode(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Account Number"
                            value={accountNumber}
                            onChange={e => setAccountNumber(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepNine;
